import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
  width: 850px;
  height: 95px;
  height: 130px;

  background: #d3baff;
  box-shadow: 0 0 20px 0 #d3baff;
  border-radius: 47.5px;
  border-radius: 65px;
  gap: 30px;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const StyledText = styled.div`
  color: black;
  font-family: var(--font), sans-serif;
  font-size: 40px;
  font-weight: 400;
  letter-spacing: 0;
  line-height: normal;
  text-transform: uppercase;
`;

const IconSpirit = styled((props) => (
  <svg width="60" height="59" viewBox="0 0 60 59" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1437_483)">
      <path
        d="M55.8425 18.9485C54.0587 18.7908 51.864 19.6095 49.963 20.5787C50.531 10.0286 46.0329 -0.971759 27.9883 0.0684403C14.8225 1.14837 9.3672 10.1309 9.16779 20.1188C7.51331 19.3687 5.73435 18.8173 4.24302 18.9485C-0.0750612 19.9875 -0.98146 26.8223 0.998115 29.1567C0.970319 29.1567 0.943731 29.1567 0.915935 29.1567C1.38122 29.8297 1.99999 30.0235 2.66589 29.9344C3.79103 29.9092 5.2594 29.0508 7.04924 26.9126C7.09516 26.8596 7.12175 26.8283 7.12296 26.8247C7.12296 26.8247 8.5732 29.6407 11.2283 31.9739C14.1578 39.9572 19.9854 46.7835 27.3514 48.6159C27.355 48.6159 27.3574 48.6171 27.361 48.6183C30.1044 49.39 32.8176 49.7307 35.1186 50.0871C38.6294 50.7204 40.9993 51.3777 41.3957 53.2691C41.4803 53.8085 41.4211 54.4489 41.1915 55.2183C41.2217 55.1653 41.2495 55.1135 41.2797 55.0618C40.9981 56.1044 40.3709 57.3914 39.3485 58.9986C39.3485 58.9986 49.9268 55.8768 50.7099 48.8507C51.2658 45.4688 49.2862 43.1849 47.7163 40.9059C47.7949 40.948 47.8396 40.9685 47.8396 40.9685C47.3163 40.2726 46.9175 39.6574 46.6226 39.1C46.0969 38.0309 45.8165 36.9028 46.0558 35.6134C46.2166 34.9344 46.5163 34.2421 46.8813 33.4391C50.786 31.0529 52.9626 26.8235 52.9626 26.8235C53.1402 27.0727 53.6599 27.6265 54.3355 28.202C54.5736 28.4127 54.8322 28.6282 55.1053 28.8328C55.0836 28.81 55.0642 28.7859 55.0425 28.763C56.4432 29.7936 58.1702 30.5761 59.0488 29.312C61.0259 26.9619 59.908 19.3085 55.8437 18.9473L55.8425 18.9485ZM27.094 6.15072C27.5774 6.39632 28.0028 6.76954 28.2505 7.22824C30.8984 10.338 27.6765 18.898 22.2066 15.9688C16.2027 12.7531 23.2194 3.38046 27.0927 6.14951L27.094 6.15072ZM38.3611 23.0046C38.0251 28.4464 33.4424 31.5634 28.2082 31.1456C23.2424 30.7495 18.1472 26.8367 18.8397 21.4046C19.0669 19.6227 20.1304 17.7518 21.9794 17.2715C24.7192 16.5611 26.7302 19.1929 29.2053 19.7215C30.2579 19.6203 31.0676 19.3302 32.2109 18.7583C32.6725 18.5272 33.0436 18.2924 33.5717 18.1864C34.414 18.0167 35.2793 18.1238 36.0625 18.4874C37.9006 19.3386 38.4771 21.0952 38.3599 23.0046H38.3611ZM37.9429 15.97C32.4743 18.8992 29.2524 10.3392 31.8991 7.22944C32.1468 6.77074 32.5734 6.39752 33.0556 6.15192C36.9302 3.38287 43.9469 12.7543 37.9417 15.9712L37.9429 15.97Z"
        fill="#303030"
      />
    </g>
    <defs>
      <clipPath id="clip0_1437_483">
        <rect width="60" height="59" fill="white" />
      </clipPath>
    </defs>
  </svg>
))``;

const MakeSpiritFriendsButton = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Container onClick={() => navigate('/friends/spirit')}>
      <StyledText>{t('friends.spirit.makeFriends')}</StyledText>
      <IconSpirit />
    </Container>
  );
};

export default MakeSpiritFriendsButton;
